module.exports = __webpack_public_path__ + "img/3.c374dc1c.png";